import { Property } from '../../types';
import { HealthIssue, PropertyHealthAudit } from '../../types/inventoryHealth';
import { checkAdminFeeRule } from './rules/adminFeeRule';
import { checkFloorNumberRule } from './rules/floorNumberRule';
import { checkElevatorFieldRule, checkHighFloorElevatorRule } from './rules/elevatorRule';
import { checkGeoConsistencyRule } from './rules/geoConsistencyRule';
import { checkZeroAntiguedadRule } from './rules/antiguedadRule';
import {
  checkPriceRule,
  checkAreaRule,
  checkRoomsAndBathsRule,
  checkPhotosRule,
  checkEstratoRule,
} from './rules/qualityRules';

export function auditProperty(property: Property): PropertyHealthAudit {
  const issues: HealthIssue[] = [];

  const adminFeeIssue = checkAdminFeeRule(property);
  if (adminFeeIssue) issues.push(adminFeeIssue);

  const floorIssue = checkFloorNumberRule(property);
  if (floorIssue) issues.push(floorIssue);

  const elevatorIssue = checkElevatorFieldRule(property);
  if (elevatorIssue) issues.push(elevatorIssue);

  const highFloorIssue = checkHighFloorElevatorRule(property);
  if (highFloorIssue) issues.push(highFloorIssue);

  const geoIssue = checkGeoConsistencyRule(property);
  if (geoIssue) issues.push(geoIssue);

  const priceIssue = checkPriceRule(property);
  if (priceIssue) issues.push(priceIssue);

  const areaIssue = checkAreaRule(property);
  if (areaIssue) issues.push(areaIssue);

  const roomsBathsIssue = checkRoomsAndBathsRule(property);
  if (roomsBathsIssue) issues.push(roomsBathsIssue);

  const photosIssue = checkPhotosRule(property);
  if (photosIssue) issues.push(photosIssue);

  const estratoIssue = checkEstratoRule(property);
  if (estratoIssue) issues.push(estratoIssue);

  const antiguedadIssue = checkZeroAntiguedadRule(property);
  if (antiguedadIssue) issues.push(antiguedadIssue);

  const criticalCount = issues.filter((i) => i.severity === 'critical').length;
  const warningCount = issues.filter((i) => i.severity === 'warning').length;

  let score = 100 - criticalCount * 25 - warningCount * 10;
  if (score < 0) score = 0;

  return {
    property,
    issues,
    isHealthy: issues.length === 0,
    hasCritical: criticalCount > 0,
    score,
  };
}
